import { Stack } from '@mui/material';
import { type ReactNode } from 'react';

import { NavigationDrawer } from './Drawer';
import { NavigationMain } from './Main';
import { SIDEBAR_NAVIGATION_COLLAPSED_WIDTH, SIDEBAR_NAVIGATION_DRAWER_WIDTH } from './constants';
import { SideNavigationMode, useSideNavigationModeContext } from './context';
import { FeatureFlagKey, useFlag } from '../../utils/flags';
import { AgenticChatHost } from '../AgenticChat/Host';
import { AgenticChatProvider } from '../AgenticChat/context';

interface NavigationLayoutProps {
  children: ReactNode;
}

export function NavigationLayout(props: NavigationLayoutProps) {
  const { children } = props;
  const { sideNavigationMode } = useSideNavigationModeContext();
  const agenticPlatformOptions = useFlag({ flagKey: FeatureFlagKey.agenticPlatformOptions });

  return (
    <AgenticChatProvider
      agenticChatMode={agenticPlatformOptions.isEnabled ? 'Enabled' : 'Disabled'}
      drawerSizing={{
        minimumDrawerWidthInPixels: 420,
        reservedWidthInPixels:
          480 +
          (sideNavigationMode === SideNavigationMode.Fixed
            ? SIDEBAR_NAVIGATION_DRAWER_WIDTH
            : SIDEBAR_NAVIGATION_COLLAPSED_WIDTH),
      }}
    >
      <Stack direction="row" height="100vh" width="100%">
        <NavigationDrawer />
        <Stack
          flex={1}
          minWidth={0}
          direction="row"
          sx={{ position: 'relative', overflow: 'hidden' }}
        >
          <NavigationMain>{children}</NavigationMain>
          <AgenticChatHost />
        </Stack>
      </Stack>
    </AgenticChatProvider>
  );
}
